// extracted by mini-css-extract-plugin
export default {"iframe":"LoginDialogContainer-iframe"};